@if (vm$ | async; as vm) {
  <ng-container [formGroup]="form">
    <div>
      {{ form.value | json }}
    </div>
    <div class="uw-dialog-header">
      <h1 class="uw-dialog-heading">{{'catalog_detail.catalog_item' | translate}}</h1>
      <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
        <mat-icon>
          close
        </mat-icon>
        {{'catalog_detail.back_to_charity' | translate}}
      </button>
    </div>
    <div class="uw-dialog-content">
      <uw-two-column-micro-layout>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="catalogTypeCode" class="uw-label">{{'catalog_detail.catalog_type' | translate}}</label>
          <select id="catalogTypeCode" class="uw-select" formControlName="catalogTypeCode">
            @for (catalogType of vm.catalogTypes; track catalogType) {
              <option [value]="catalogType.catalogTypeCode"> {{ vm.currentLang == 'en' ? catalogType.descriptionEn: catalogType.descriptionFr }}</option>
            }
          </select>
        </div>
        <h1>{{ form.value.catalogId }}</h1>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          @if (catalogsByType$) {
            <label for="catalogId" class="uw-label">{{'catalog_detail.select_catalog' | translate}}</label>
            <select id="catalogId" formControlName="catalogId" class="uw-select">
              <option [value]="DEFAULT_OPTION">{{'catalog_detail.select_catalog' | translate}}</option>
              @for (catalog of catalogsByType$ | async; track catalog) {
                <option [value]="catalog.catalogId">
                  {{ catalog.catalogId }} - {{ catalog.externalCatalogId }} - {{catalog.name }}
                </option>
              }
            </select>
          }
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="parentName" class="uw-label">{{'catalog_detail.parent' | translate}}</label>
          <input id="parentName" type="text" formControlName="parentName">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="alias" class="uw-label">{{'catalog_detail.alias' | translate}}</label>
          <input id="alias" type="text" formControlName="alias">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="charityName" class="uw-label">{{'catalog_detail.charity_name' | translate}}</label>
          <input id="charityName" type="text" formControlName="charityName">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="frenchName" class="uw-label">{{'catalog_detail.french_name' | translate}}</label>
          <input id="frenchName" type="text" formControlName="frenchName">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="keywords" class="uw-label">{{'catalog_detail.keywords' | translate}}</label>
          <input id="keywords" type="text" formControlName="keywords">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="fundKey" class="uw-label">{{'catalog_detail.fund_key' | translate}}</label>
          <input id="fundKey" type="text" formControlName="fundKey">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutLeft>
          <label for="charitableRegistrationNumber" class="uw-label">{{'catalog_detail.cra_no' | translate}}</label>
          <input id="charitableRegistrationNumber" type="text" formControlName="charitableRegistrationNumber">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <label for="address" class="uw-label">{{'catalog_detail.address_line' | translate}}</label>
          <input id="address" type="text" formControlName="address">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <label for="postalCode" class="uw-label">{{'common.postal_code' | translate}}</label>
          <input id="postalCode" type="text" formControlName="postalCode">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <label for="city" class="uw-label">{{'common.city' | translate}}</label>
          <input id="city" type="text" formControlName="city">
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <label for="province" class="uw-label">{{'common.province' | translate}}</label>
          <select id="province" class="uw-select" formControlName="province">
            @for (province of provinces; track province) {
              <option [value]="province">
                {{ province }}
              </option>
            }
          </select>
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <mat-checkbox formControlName="isEnabled">{{'common.is_enabled' | translate}}</mat-checkbox>
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <mat-checkbox formControlName="isRevoked">{{'common.is_revoked' | translate}}</mat-checkbox>
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <mat-checkbox formControlName="isPrivate">{{'common.is_private' | translate}}</mat-checkbox>
        </div>
        <div class='uw-field' uwTwoColumnMicroLayoutRight>
          <mat-checkbox formControlName="unitedWayAgency">{{'catalog_detail.united_way_agency' | translate}}</mat-checkbox>
        </div>
        <div class='uw-field'uwTwoColumnMicroLayoutRight>
          <label for="fundKeyGuId" class="uw-label">{{'catalog_detail.fund_key_id' | translate}}</label>
          <input id="fundKeyGuId" type="text" formControlName="fundKeyGuId">
        </div>
        <div class='uw-field'uwTwoColumnMicroLayoutRight>
          <label for="sortOrder" class="uw-label">{{'common.sort_order' | translate}}</label>
          <select id="sortOrder" formControlName="sortOrder" class="uw-select">
            @for (sortOrder of sortOrders; track sortOrder) {
              <option [value]="sortOrder">
                {{ sortOrder }}
              </option>
            }
          </select>
        </div>
      </uw-two-column-micro-layout>
    </div>
    <div class="uw-dialog-footer">
      <div class="uw-actions">
        <button class="uw-stroked-button" mat-dialog-close>
          {{'buttons.cancel' | translate}}
        </button>
        <button class="uw-default-button" (click)="handleSave(form.value)" [disabled]="form.pristine || !form.valid">
          {{'buttons.save' | translate}}
        </button>
      </div>
    </div>
  </ng-container>
}
